import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';

const useSelectedStore = () => {
    const { selectedStore, allStore } = useSelector((state: any) => state?.store);
    const isStoreSelected = useMemo(() => {
        return Object.keys(selectedStore || {}).length > 0;
    }, [selectedStore]);

    const domain_setting = useMemo(() => {
        return selectedStore?.domain_setting;
    }, [selectedStore?.domain_setting])

    const rating = useMemo(() => {
        return {
            rating: selectedStore?.rating,
            isRating: selectedStore?.rating > 0 ? true:false
        }
    }, [selectedStore?.rating])

    return {
        selectedStore, isStoreSelected, allStore, platformFee: (domain_setting?.platform_fee || 0), rating


    }
}

export default useSelectedStore
//  <div className="md:min-w-36 min-w-10 h-10 flex justify-center items-center">
